import React from 'react';
import PropTypes from 'prop-types';
import BookMarketerPage from 'components/BookMarketerPage';

function BookMarketer({ data }) {
  return (
    <BookMarketerPage
      contentfulSessions={data.allContentfulMarketerSession.edges}
    />
  );
}

BookMarketer.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default BookMarketer;

export const query = graphql`
  query MarketerSessionQuery {
    allContentfulMarketerSession(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          node_locale
          name
          icon {
            responsiveResolution(width: 400) {
              width
              height
              src
              srcSet
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/BookMarketer.js